import { render, staticRenderFns } from "./AppDespesasFixas.vue?vue&type=template&id=9237e460&"
import script from "./AppDespesasFixas.vue?vue&type=script&lang=js&"
export * from "./AppDespesasFixas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports